import { useCallback, useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { CuentaSelector } from 'core/cuenta/components/CuentaSelector/CuentaSelector';
import { ReportFormActions } from '../ReportFormActions/ReportFormActions';
import { useNotifications } from 'shared/notifications';
import { UltimasLiquidacionesContext } from 'core/reporte/contexts/UltimasLiquidacionesContext';

interface UltimasLiquidacionesFormValues {
  numeroCuenta: number | null;
}

const EMPTY_FORM_VALUE: UltimasLiquidacionesFormValues = {
  numeroCuenta: null,
};

export const UltimasLiquidacionesForm = () => {
  const { consultar, clear, isLoading } = useContext(UltimasLiquidacionesContext);
  const methods = useForm<UltimasLiquidacionesFormValues>({
    defaultValues: EMPTY_FORM_VALUE,
  });
  const { addNotification } = useNotifications();

  const handleClear = useCallback(() => {
    methods.reset(EMPTY_FORM_VALUE);
    clear();
  }, [methods, clear]);

  const handleConsultar = async (event: React.FormEvent) => {
    event.preventDefault();
    const cuenta = methods.getValues('numeroCuenta');

    if (!cuenta) {
      addNotification('Debe seleccionar una cuenta.', 'warning');
      return;
    }

    await consultar(cuenta);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleConsultar}>
        <Row>
          <Col>
            <CuentaSelector
              name="numeroCuenta"
              label="Cuenta"
              emptyOptionHintOnOpen
              filtros={{ cuentasHuerfanas: false }}
              registerOptions={{ required: 'Debe seleccionar una cuenta' }}
            />
          </Col>
        </Row>
        <ReportFormActions
          onClear={handleClear}
          isLoading={isLoading}
          submitLabel="Consultar"
        />
      </form>
    </FormProvider>
  );
};
